import { render, staticRenderFns } from "./Notifica.vue?vue&type=template&id=2e1e4c99&scoped=true&"
import script from "./Notifica.vue?vue&type=script&lang=js&"
export * from "./Notifica.vue?vue&type=script&lang=js&"
import style0 from "./Notifica.vue?vue&type=style&index=0&id=2e1e4c99&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1e4c99",
  null
  
)

component.options.__file = "Notifica.vue"
export default component.exports